import { render, staticRenderFns } from "./packingList.vue?vue&type=template&id=4f27ad3b&scoped=true&"
import script from "./packingList.vue?vue&type=script&lang=js&"
export * from "./packingList.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=4f27ad3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27ad3b",
  null
  
)

export default component.exports